module.exports = __webpack_public_path__ + "img/yellow_blue.cc97a1c4.jpg";